import "@/components/alerts/alerts.scss";

import React, { useContext, useEffect, useState } from "react";

import { BulletinResource, getBulletinByIdView } from "@rubi/api-generated";
import { toast } from "@rubi/ui";
import { useSearchParams } from "react-router-dom";

import { DisplayAlert } from "@/components/alerts/add/DisplayAlert";
import { SingleAlertContext } from "@/components/alerts/context";
import { updateToContextStructure } from "@/components/alerts/utils";
import { IEvidenceFile, IPdfFile } from "@/types";

export const AlertView = () => {
  const { setAlertProperties } = useContext(SingleAlertContext);
  const [searchParams] = useSearchParams();
  const view_token = searchParams.get("view_token") ?? "";

  const [currentItem, setCurrentItem] = useState<BulletinResource | null>(null);

  const getBulletinByToken = (token: string) => {
    getBulletinByIdView({ query: { access_token: token } })
      .then((res) => {
        setCurrentItem(res.data!);
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  useEffect(() => {
    if (!view_token || view_token === "") return;
    getBulletinByToken(view_token);
  }, [view_token]);

  useEffect(() => {
    if (currentItem) {
      const alertProperties = updateToContextStructure(currentItem);
      setAlertProperties(alertProperties);
    }
  }, [currentItem]);

  return (
    <div className="alert-container">
      {currentItem && (
        <DisplayAlert
          mode="view"
          view_token={view_token}
          issuing_police_service={
            currentItem.issuing_police_service?.name ?? ""
          }
          associatedCrimes={currentItem.associated_crime}
          occurrenceNumbers={currentItem.occurrence_number}
          issuedTime={currentItem.issued_time ?? null}
          description={currentItem.description}
          pdf={currentItem.pdf as IPdfFile | Record<string, never>}
          evidences={
            currentItem.evidence_files as { [key: string]: IEvidenceFile }
          }
        />
      )}
    </div>
  );
};
